module.exports = __webpack_public_path__ + "static/media/UnityPoint.a00da5af.png";